"use client"
import React, { useState } from 'react';
import { FaDownload } from 'react-icons/fa6';
import DownloadNextVentesModal from './DownloadNextVentesModal';
import { Button } from 'flowbite-react';
import { Prisma } from '@prisma/client';

type DownloadNextVentesProps = 
{
    tgis?: Prisma.TgiGetPayload<{}>[]
    ventes: Prisma.VenteGetPayload<{}>[]
}
const DownloadNextVentes = ({ tgis, ventes }: DownloadNextVentesProps) => 
{
    const [showModalDownload, setShowModalDownload] = useState<boolean>(false)
    return (
        <>
            <div className='w-full mb-4'>
                <Button className="w-full px-2 shadow-md" color="dark" size="sm" onClick={() => setShowModalDownload(true)}>
                    <div className="flex items-center text-sm">
                        <FaDownload className='me-2' />T&eacute;l&eacute;charger les prochaines ventes
                    </div>
                </Button>
                {showModalDownload &&
                    <DownloadNextVentesModal showModal={showModalDownload} setShowModal={setShowModalDownload} 
                        tgis={tgis} ventes={ventes} />
                }
            </div>
        </>
    )
}

export default DownloadNextVentes;